var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeftChev(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 18,
    viewBox: "0 0 10 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.53122 15.9698C9.6009 16.0395 9.65617 16.1222 9.69388 16.2132C9.7316 16.3043 9.75101 16.4019 9.75101 16.5004C9.75101 16.599 9.7316 16.6965 9.69388 16.7876C9.65617 16.8786 9.6009 16.9614 9.53122 17.031C9.46153 17.1007 9.37881 17.156 9.28776 17.1937C9.19672 17.2314 9.09914 17.2508 9.00059 17.2508C8.90204 17.2508 8.80446 17.2314 8.71342 17.1937C8.62237 17.156 8.53965 17.1007 8.46996 17.031L0.969965 9.53104C0.900232 9.46139 0.844914 9.37867 0.80717 9.28762C0.769427 9.19657 0.75 9.09898 0.75 9.00042C0.75 8.90186 0.769427 8.80426 0.80717 8.71321C0.844914 8.62216 0.900232 8.53945 0.969965 8.46979L8.46996 0.969792C8.6107 0.829062 8.80157 0.75 9.00059 0.75C9.19961 0.75 9.39048 0.829062 9.53122 0.969792C9.67195 1.11052 9.75101 1.30139 9.75101 1.50042C9.75101 1.69944 9.67195 1.89031 9.53122 2.03104L2.5609 9.00042L9.53122 15.9698Z",
    fill: "#1F2124"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftChev);
export default __webpack_public_path__ + "static/media/LeftChev.903d79274973cb1ba2fbcf46a684945f.svg";
export { ForwardRef as ReactComponent };